import { render, staticRenderFns } from "./SealUploadComponent.vue?vue&type=template&id=b06837c6&scoped=true&"
import script from "./SealUploadComponent.vue?vue&type=script&lang=js&"
export * from "./SealUploadComponent.vue?vue&type=script&lang=js&"
import style0 from "./SealUploadComponent.vue?vue&type=style&index=0&id=b06837c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06837c6",
  null
  
)

export default component.exports